export const pathOutline = [
  {
    title: "About",
    name: "About",
    desc: "Misc. information for this platform",
    path: "/about",
  },
  {
    title: "Trait mapping",
    desc: "Map a trait to other traits by semantic similarity",
    name: "Home",
    path: "/",
  },
  {
    title: "Pairwise similarity",
    desc: "Compute the pairwise semantic similarity of traits",
    name: "Pairwise",
    path: "/pairwise",
  },
  {
    title: "Data explorer",
    desc: "Explore curated data (work in progress)",
    name: "DataExplorer",
    path: "/data-explorer",
  },
];
